// extracted by mini-css-extract-plugin
export default {"container":"styles---container---bo3Qk","logo":"styles---logo---Vd83o","square":"styles---square---wt9tO"};